'use client'

import { LogoFullSizable } from '@/root/src/components/Logo/LogoFullSizable'
import { Brain, Rocket, Shield, Target, Trophy } from 'lucide-react'

const benefits = [
    {
        icon: Brain,
        title: 'Verstehe deine Stärken',
        description: 'Finde heraus, was dir liegt - durch einfache Gespräche',
    },
    {
        icon: Target,
        title: 'Entdecke passende Berufsfelder',
        description: 'Lerne Berufe kennen, die zu deinen Interessen und Stärken passen',
    },
    {
        icon: Rocket,
        title: 'Lass dich inspirieren',
        // description: 'Entdecke Berufe, auf die du vielleicht noch gar nicht gekommen bist',
        description: 'Entdecke Berufe und Unternehmen, an die du vielleicht noch gar nicht gedacht hast',
    },
    {
        icon: Trophy,
        title: 'Finde passende Unternehmen',
        description: 'Finde Unternehmen, die zu deinen Interessen, Stärken und deinen Zielen passen',
    },
    // {
    //     icon: Trophy,
    //     title: 'Einfach loslegen',
    //     description: 'Starte kostenlos und entdecke Berufe, die zu dir passen',
    // },
    // {
    //     icon: Trophy,
    //     title: 'Gamification & Belohnungen',
    //     description: 'Sammle XP, erreiche Meilensteine, bleib motiviert',
    // },
]

export function Benefits() {
    return (
        <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-gradient-to-br from-primary/20 via-secondary/20 to-accent/20">
            {/* Background effects */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/30 rounded-full blur-3xl animate-pulse" />
                <div
                    className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-secondary/30 rounded-full blur-3xl animate-pulse"
                    style={{ animationDelay: '1s' }}
                />
                <div
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-accent/20 rounded-full blur-3xl animate-pulse"
                    style={{ animationDelay: '2s' }}
                />
            </div>

            {/* Content */}
            <div className="relative z-10 flex flex-col justify-center p-12 xl:p-16">
                {/* Logo & Claim */}
                <div className="mb-12">
                    <LogoFullSizable h="h-18 xl:h-30" mauto="" />
                    <h1 className="text-4xl xl:text-5xl font-bold mb-4 leading-tight">
                        <span className="gradient-text">Walter - dein persönlicher</span>
                        <br />
                        <span className="gradient-text">Berufscoach</span>
                    </h1>
                    <p className="text-lg text-muted-foreground max-w-md">
                        Sprich mit Walter über deine Interessen, Stärken oder Berufe, die dich interessieren. So findest
                        du <strong>Berufe und Unternehmen</strong>, die gut zu dir passen -{' '}
                        <strong>einfach und kostenlos</strong>.
                    </p>
                </div>

                {/* Benefits */}
                <div className="space-y-4">
                    {benefits.map((benefit, index) => (
                        <div
                            key={index}
                            className="flex items-start gap-4 p-4 rounded-xl bg-background/30 backdrop-blur-sm border border-white/10 hover:bg-background/40 transition-colors"
                        >
                            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
                                <benefit.icon className="w-5 h-5 text-primary" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-foreground mb-1">{benefit.title}</h3>
                                <p className="text-sm text-muted-foreground">{benefit.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Trust indicators */}
                <div className="mt-12 flex flex-col gap-4">
                    {/* <div className="flex items-center gap-2 text-muted-foreground">
                        <div className="flex -space-x-2">
                            {[...Array(4)].map((_, i) => (
                                <div
                                    key={i}
                                    className="w-8 h-8 rounded-full bg-gradient-to-br from-primary/40 to-secondary/40 border-2 border-background flex items-center justify-center"
                                >
                                    <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" />
                                </div>
                            ))}
                        </div>
                        <span className="text-sm ml-2">
                            Bereits <span className="text-primary font-semibold">1.000+</span> Nutzer
                        </span>
                    </div> */}

                    {/* DSGVO Badge */}
                    <div className="flex items-center gap-2 text-muted-foreground/80">
                        <Shield className="w-4 h-4 text-green-500" />
                        <span className="text-xs">100% DSGVO-konform · Deine Daten gehören dir</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
